export const viewports = {
    MOBILE: {
        name: 'mobile',
        minWidth: 0,
        maxWidth: 768,
    },
    TABLET: {
        name: 'tablet',
        minWidth: 769,
        maxWidth: 1023,
    },
    DESKTOP: {
        name: 'desktop',
        minWidth: 1024,
        maxWidth: 1215,
    },
    WIDESCREEN: {
        name: 'widescreen',
        minWidth: 1216,
        maxWidth: 1407,
    },
    FULL_HD: {
        name: 'full-hd',
        minWidth: 1408,
        maxWidth: Infinity,
    },
};
